module.exports = __webpack_public_path__ + "img/bell.84ed0d67.svg";